import Helmet from 'react-helmet';
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, DropdownButton, OverlayTrigger, Tooltip } from 'react-bootstrap';

import NoData from '../../components/NoData/NoData';
import Loading from '../../components/Loading/Loading';
import Header from '../../components/Header/Header';
import Confirm from '../../components/Confirm/Confirm';
import { Link } from 'react-router';

import {
  requestData,
  selectPortfolio,
  deletePortfolio,
  saveSelected,
  saveSelectedPortfolioBreakdown,
  listAll
} from './PortfolioActions';
import {listAll as streamsAll} from '../ReportConfig/ReportActions';
import LineChart from '../ReportConfig/components/LineChart';
import ValueStreamSelector from '../ReportConfig/components/ValueStreamSelector';
import SubscribeEDAddOn from '../../components/SubscribeEDAddOn/SubscribeEDAddOn';

import settingsIcon from '../../assets/img/settings-icon.svg';
import createIcon from '../../assets/img/createDashboard-icon.svg';
import lineChartOnIcon from '../../assets/img/line-chart-icon-on.svg';
import lineChartOffIcon from '../../assets/img/line-chart-icon-off.svg';
import deleteIcon from '../../assets/img/delete.svg';
import editIcon from '../../assets/images/edit-blue.svg';

import portfolioIcon from '../../assets/images/portfolio-default-icon.jpg';

import expandIcon from '../../assets/img/zoom-icon-off.svg';
import collapseIcon from '../../assets/img/zoom-icon-on.svg';

import momentDurationFormatSetup from '../../util/moment-duration';

import { PieChartWidget } from '../ReportConfig/components/PieChartWidget';

import { trackPortfolioView } from '../../util/mixpanel';

import '../ReportConfig/Reports.scss';
import _ from 'lodash';

function formatCycletimeLabel(point, timePrecision) {
  const duration = moment.duration(point.y, 'minutes').format(timePrecision, { trim: 'mid both' });
  return `(${duration}) ${(point.percentage || 0).toFixed(2)}%`;
}

function formatThroughputLabel(point) {
  return `${(point.percentage || 0).toFixed(2)}% (${point.y} ${point.y > 1 ? 'items' : 'item'})`;
}

class Portfolios extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comparison: false,
      percentile: (props.filters && props.filters.percentile) || 85,
      threshold: (props.filters && props.filters.threshold) || 5,
      dateRange: props.dateRange || 'lastMonth',
      dateFormat: (props.filters && props.filters.dateFormat) || 'D/MM/YY',
      isFullScreen: '',
      cycletime: {
        search: '',
        value: [],
        name: '',
        drilldown: '',
        open: false
      },
      throughput: {
        search: '',
        value: [],
        name: '',
        drilldown: '',
        open: false
      },
      wip: {
        search: '',
        value: [],
        name: '',
        open: false
      },
      wat: {
        search: '',
        value: [],
        name: '',
        open: false
      },
      page: 1,
      th: false,
      wp: false,
      wat: false,
      ct: false,
      fe: false
    };
  }

  componentDidMount() {
    this.chartsInitialized = false;
    const currentSelectedPortfolioIdFromProps = this.props.selectedPortfolio && this.props.selectedPortfolio._id;
    const portfolioIdToLoad = this.props.routeParams.id || currentSelectedPortfolioIdFromProps;

    if (!this.props.streams.length && !this.props.streamsLoading) {
      this.props.getStreams();
    }

    if (!this.trialExpired() && portfolioIdToLoad) {
      this.props.requestData(portfolioIdToLoad);
    } else if (!this.trialExpired() && this.props.selectedPortfolio && this.props.stats && this.props.stats.cycletimeBreakdowns) {
      this._syncBreakdownSettingsAndCharts(this.props);
    }
  }

componentDidUpdate(prevProps, prevState) {
    const prevPortfolioIdFromProps = prevProps.selectedPortfolio && prevProps.selectedPortfolio._id;
    const currentPortfolioIdFromProps = this.props.selectedPortfolio && this.props.selectedPortfolio._id;
    const prevEffectivePortfolioId = prevProps.routeParams.id || prevPortfolioIdFromProps;
    const currentEffectivePortfolioId = this.props.routeParams.id || currentPortfolioIdFromProps;

    const portfolioContextChanged = prevEffectivePortfolioId !== currentEffectivePortfolioId;
    const selectedPortfolioObjectChanged = !_.isEqual(prevProps.selectedPortfolio, this.props.selectedPortfolio);

    if (this.props.streams && !this.props.streamsLoading && this.props.streams.length < 1 && this.props.location.pathname.startsWith('/portfolios')) {
      this.props.router.push('/configure?fromPortfolio=true');
    }

    if (portfolioContextChanged && currentEffectivePortfolioId) {
      this.props.requestData(currentEffectivePortfolioId);
      this.chartsInitialized = false;
    } else if (selectedPortfolioObjectChanged || !this.chartsInitialized) {      
      this._syncBreakdownSettingsAndCharts(this.props);
    }
  }

  updateFontSize = chart => {};

  handleConfigure = () => {
    this.props.router.push('/portfolio/' + this.props.selectedPortfolio._id);
  };

  handleNew = () => {
    this.props.select({ isNew: true });
    this.props.router.push('/portfolio');
  };

  changePercentile = value => {
    this.setState({ percentile: parseInt(value, 10) });

    trackReportConfigChange(this.getDashboardsNames(), 'ct_percentile', { percent: parseInt(value, 10) });
  };

  changeThreshold = value => {
    this.setState({ threshold: value });

    trackReportConfigChange(this.getDashboardsNames(), 'controls', { variation: value });
  };

  onBreakdownChange = (widget, field) => {
    const { selectedPortfolio, saveSelectedBreakdown, wallmode } = this.props;
    const portfolioId = selectedPortfolio && selectedPortfolio._id;
    if (!portfolioId) {
      return;
    }
     if (!wallmode) {
      saveSelectedBreakdown(portfolioId, widget, field.id);
    }
    this.setState({ [widget]: { ...this.state[widget], name: field.id, search: field.id, value: [field.id] } });
  }

  handleResize = ev => {
    const chart = ev.target.id.split('-')[1];
    if (this.state.isFullScreen) {
      this.setState(
        { isFullScreen: '' },
        () => this.updateFontSize(chart)
      );
    } else {
      this.setState(
        { isFullScreen: chart },
        () => this.updateFontSize(chart)
      );
      trackPortfolioView(chart);
    }
  };

  trackChartDetailsView(chart, isHidden) {
    if (!isHidden) {
      trackPortfolioView(chart + '_details');
    }
  }
 getBreakDownList(chart) {
    const { filters } = this.props;
    const isCycletime = chart === 'cycletime';
    if (filters) {
      const list = _(filters.dashboards)
        .map(d => d.allCustomFields)
        .flatten()
        .groupBy('name')
        .map((value, key) => ({ name: key, id: _.map(value, v => v.id) }))
        .value();

      if (this.props.app === 'file') {
        const flags = { azure: false, jira: false };
        _.forEach(filters.dashboards, d => {
          if (!d.isCsv && d.isAzure) flags.azure = true;
          if (!d.isCsv && !d.isAzure) flags.jira = true;
        });
        if (flags.azure) {
          list.push({ name: 'Work item types', id: ['labels'] });
        }
        if (flags.jira) {
          list.push({ name: 'Priorities', id: ['labels'] });
        }
      }

      switch (this.props.app) {
        case 'azure':
          list.push({ name: 'Work item types', id: ['labels'] });
          isCycletime && list.push({ name: 'Columns', id: ['statuses'] });
          break;
        case 'asana':
          list.push({ name: 'Tags', id: ['labels'] });
          isCycletime && list.push({ name: 'Sections', id: ['statuses'] });
          break;
        case 'jira':
          list.push({ name: 'Priorities', id: ['labels'] });
          isCycletime && list.push({ name: 'Statuses', id: ['statuses'] });
          break;
        case 'trello':
          list.push({ name: 'Labels', id: ['labels'] });
          isCycletime && list.push({ name: 'Lists', id: ['statuses'] });
          break;
        case 'file': 
          isCycletime && list.push({ name: 'Statuses', id: ['statuses'] });
          break;
      }

      return _.orderBy(list, 'name');
    }
    return [];
  }
  
  getBreakDownName(values) {
    const { filters } = this.props;
    let name;

    if (values.indexOf('labels') > -1) {
      switch (this.props.app) {
        case 'azure':
          return 'Work item types';
        case 'trello':
          return 'Labels';
        case 'asana':
          return 'Tags';
        case 'jira':
          return 'Priorities';
      }
    }

    if (values.indexOf('statuses') > -1) {
      switch (this.props.app) {
        case 'jira':
        case 'file': 
          return 'Statuses';
        case 'azure':
          return 'Columns';
        case 'trello':
          return 'Lists';
        case 'asana':
          return 'Sections';
      }
    }

    _.some(values, value => {
      return _.some(filters.dashboards, dashboard => {
        const cf = _.find(dashboard.allCustomFields, { id: value });
        if (cf) {
          name = cf.name;
          return true;
        }
      });
    });
    return name;
  }
  
  _deriveBreakdownStateForWidget(widgetType, currentProps = this.props) {
    const { stats } = currentProps;
    const { selectedPortfolio } = this.props;
    
    const breakdownsAvailableMap = stats && stats[`${widgetType}Breakdowns`];
    let defaultName = ''; 
    let derivedName = '';

    if (breakdownsAvailableMap && typeof breakdownsAvailableMap === 'object' && Object.keys(breakdownsAvailableMap).length > 0) {
      const breakdownKeys = Object.keys(breakdownsAvailableMap); 
      defaultName = breakdownKeys[0]; 
      const persistedPreferences = selectedPortfolio && selectedPortfolio[`${widgetType}`];
      const persistedPreference = persistedPreferences && persistedPreferences.length > 0 ? persistedPreferences[0] : null;
      if (persistedPreference && breakdownKeys.includes(persistedPreference)) {
        derivedName = persistedPreference;
      } else {
        derivedName = defaultName;
      }
    }   
    return { ...this.state[widgetType], name: derivedName, search: derivedName, value: [derivedName] };
  }

  
  _syncBreakdownSettingsAndCharts(propsToUse = this.props) {
    const { stats, selectedPortfolio } = propsToUse;

    if (!stats || !selectedPortfolio || !selectedPortfolio._id || !stats.cycletimeBreakdowns || !stats.throughputBreakdowns) {
      return;
    }

    const newCycleTimeState = this._deriveBreakdownStateForWidget('cycletime', propsToUse);
    const newThroughputState = this._deriveBreakdownStateForWidget('throughput', propsToUse);
    const stateToUpdate = {};
    let needsStateUpdate = false;

    if (!_.isEqual(this.state.cycletime.name, newCycleTimeState.name)) {
      stateToUpdate.cycletime = { ...this.state.cycletime, ...newCycleTimeState };
      needsStateUpdate = true;
    }
    if (!_.isEqual(this.state.throughput.name, newThroughputState.name)) {
      stateToUpdate.throughput = { ...this.state.throughput, ...newThroughputState };
      needsStateUpdate = true;
    }

    if (needsStateUpdate) {
      this.setState(stateToUpdate);
    }
    this.chartsInitialized = true;
  }

  renderPercentiles() {
    return (
      <div className='report-info-box'>
        {this.props.stats.avgPercentiles &&
          this.props.stats.avgPercentiles.map((p, i) => {
            return (
              <div key={i}>
                <h4>
                  {moment.duration(p.value, 'minutes').format('d[d] h[h] m[m]', { trim: 'mid both' })}
                </h4>
                <p>{p.text}th percentile</p>
              </div>
            );
          })}
      </div>
    );
  }

  renderButtons() {
    return [
      <SubscribeEDAddOn></SubscribeEDAddOn>,
       <DropdownButton
          key="1"
          id="createportfolio-dropdown"
          variant='secondary'
          size='sm'
          title={
                      <OverlayTrigger placement="bottom"
                        overlay={<Tooltip id="tooltip-createportfolio" className='tooltip_dark'>Create Portfolio</Tooltip>}>
                        <img src={createIcon} alt="" />
                      </OverlayTrigger>
                    }
          >
          <li>
            <Link key="1" onClick={this.handleNew} className='btn'>
              <span className="title"><img src={createIcon} alt="#"/> Create Portfolio</span>
              <span className="help-text">
                Select the value streams you want to include to build a portfolio and track performance across your organization.
              </span>                        
            </Link>
          </li>             
      </DropdownButton>,      
      this.props.selectedPortfolio && (
        <DropdownButton
          key="2"
          id="dashboards-dropdown"
          size="sm"
          variant="secondary"
          title={
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-settings" className="tooltip_dark">
                  Portfolio Settings
                </Tooltip>
              }
            >
              <img src={settingsIcon} alt="" />
            </OverlayTrigger>
          }
        >
          <li onClick={ev => this.handleConfigure(this.props.selectedPortfolio)}>
            <div className="btn">
              <span className="title">
                <img src={editIcon} alt="#" /> Edit Portfolio
              </span>
              <span className="help-text">
                Add or remove value streams connected to this portfolio and update your data.
              </span>
            </div>
          </li>
          <li>
            <Confirm
              onConfirm={ev => this.props.remove(this.props.selectedPortfolio._id)}
              body={
                <p>
                  Are you sure you want to delete <strong>{this.props.selectedPortfolio.name}</strong>?
                </p>
              }
              confirmText="Delete"
              icon={deleteIcon}
              title="Delete portfolio"
            >
              <div className="btn">
                <span className="title red">
                  <img src={deleteIcon} alt="#" />
                  Delete Portfolio
                </span>
                <span className="help-text">Permanently delete the portfolio. This action cannot be undone.</span>
              </div>
            </Confirm>
          </li>
        </DropdownButton>
      )
    ];
  }

  renderPortfolio() {
    const flowEfficiency = !isNaN(this.props.stats.avgFe);
    const breakDownItemsCt = this.props.stats.cycletimeBreakdowns
      ? Object.keys(this.props.stats.cycletimeBreakdowns).map(key => ({ name: key, id: key }))
      : [];
    const breakDownItemsTh = this.props.stats.throughputBreakdowns
      ? Object.keys(this.props.stats.throughputBreakdowns).map(key => ({ name: key, id: key }))
      : [];
    const subsetColors = _(this.props.trends && this.props.trends.throughput)
      .map(({ name, color }) => [name, color])
      .fromPairs()
      .value();

    return [
      <div className="report-wrap portfolios">
        {this.props.loading && (
          <div className="table-loading">
            <Loading />
          </div>
        )}

        {/*<NoData show={!this.props.trends.avgCt} />*/}

        <div className="row-cell-list">
          <PieChartWidget
            className="widget cell cell-33"
            name="cycletime-breakdown"
            title={
              <React.Fragment>
                Avg. Cycle Time <span>{moment.duration(this.props.stats.avgCt, 'minutes').format('d[d] h[h] m[m]', { trim: 'mid both' })}</span>
              </React.Fragment>
            }
            formatter={(p) => formatCycletimeLabel(p, this.props.filters.timePrecision)}
            breakdowns={this.props.stats.cycletimeBreakdowns}
            options={breakDownItemsCt}
            colors={subsetColors}
            selected={this.state.cycletime.name}
            // onResize={() => trackExecutiveDashboardView('cycletime-breakdown')}
            onSelect={(field) => this.onBreakdownChange('cycletime', field)}
          />
          <PieChartWidget
            className="widget cell cell-33"
            name="throughput-breakdown"
            title={
              <React.Fragment>
                Throughput <span>{this.props.stats.avgThroughput} work items</span>
              </React.Fragment>
            }
            formatter={(p) => formatThroughputLabel(p)}
            breakdowns={this.props.stats.throughputBreakdowns}
            options={breakDownItemsTh}
            colors={subsetColors}
            selected={this.state.throughput.name}
            // onResize={() => trackExecutiveDashboardView('throughput-breakdown')}
            onSelect={(field) => this.onBreakdownChange('throughput', field)}
          />
          <div className='average cell-33'>
            {flowEfficiency && (
              <div className='cell cell-height-auto'>
                <div className='cell-header'>
                  <h4>Avg. Flow Efficiency <span>{this.props.stats.avgFe}%</span></h4>
                </div>
              </div>
            )}
            <div className='cell cell-height-full'>
              <div className='cell-header'>
                <h4>Avg. Cycle Time Percentiles</h4>
              </div>
              <div className="cell-content">
                {this.renderPercentiles()}
              </div>
            </div>
          </div>
          
          <div className={`cell ${this.state.isFullScreen === 'wip' ? 'fullscreen' : ''} ${ this.state.wp ? 'line-chart' : '' }`}>
            <div className='cell-header'>
              <h4>WIP Trends</h4>
              <Button variant="flat" size="md" onClick={() => { this.setState({ wp: !this.state.wp }); this.trackChartDetailsView('wip', this.state.wp); }}>
                <img src={this.state.wp ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
              </Button>
              <Button id="fullscreen-wip" variant="flat" size="md" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'wip' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
  
            <div className="cell-content">
              <LineChart
                id="wip"
                className='chart'
                detailed={this.state.wp}
                isFullScreen={this.state.isFullScreen === 'wip'}
                showExactDate={true}
                plural={false}
                tooltipLabel="Work items"
                unit="item"
                data={this.props.trends.wip}
              />
            </div>
          </div>

          <div className={`cell ${this.state.isFullScreen === 'tht' ? 'fullscreen' : ''} ${ this.state.th ? 'line-chart' : '' }`}>
            <div className='cell-header'>
              <h4>Throughput Trends</h4>
              <Button variant="flat" size="md" onClick={() => { this.setState({ th: !this.state.th }); this.trackChartDetailsView('tht', this.state.th); }}>
                <img src={this.state.th ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
              </Button>
              <Button id="fullscreen-tht" variant="flat" size="md" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'tht' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
  
            <div className="cell-content">
              <LineChart
                id="throughput"
                className='chart'
                detailed={this.state.th}
                isFullScreen={this.state.isFullScreen === 'tht'}
                plural={true}
                tooltipLabel="Work items"
                unit="item"
                data={this.props.trends.throughput}
              />
            </div>
          </div>

          <div className={`cell ${this.state.isFullScreen === 'wat' ? 'fullscreen' : ''} ${ this.state.wat ? 'line-chart' : '' }`}>
            <div className='cell-header'>
              <h4>WIP Age Trends</h4>
              <Button variant="flat" size="md" onClick={() => {this.setState({ wat: !this.state.wat }); this.trackChartDetailsView('wat', this.state.wat); }} >
                <img src={this.state.wat ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
              </Button>
              <Button id="fullscreen-wat" variant="flat" size="md" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'wat' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
  
            <div className="cell-content">
              <LineChart
                id="wat"
                className='chart'
                detailed={this.state.wat}
                showExactDate={true}
                isFullScreen={this.state.isFullScreen === 'wat'}
                tooltipLabel="Avg. WIP Age Time"
                unit="day"
                data={this.props.trends.avgWat}
              />
            </div>
          </div>

          <div className={`cell ${this.state.isFullScreen === 'ctt' ? 'fullscreen' : ''} ${ this.state.ct ? 'line-chart' : '' }`}>
            <div className='cell-header'>
              <h4>Cycle Time Trends</h4>
              <Button variant="flat" size="md" onClick={() => { this.setState({ ct: !this.state.ct }); this.trackChartDetailsView('ctt', this.state.ct); }} >
                <img src={this.state.ct ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
              </Button>
              <Button id="fullscreen-ctt" variant="flat" size="md" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'ctt' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
  
            <div className="cell-content">
              <LineChart
                id="ct"
                className='chart'
                detailed={this.state.ct}
                isFullScreen={this.state.isFullScreen === 'ctt'}
                tooltipLabel="Avg. Cycle Time"
                unit="day"
                data={this.props.trends.avgCt}
              />
            </div>
          </div>

          <div className={`cell ${this.state.isFullScreen === 'percentile' ? 'fullscreen' : ''}`}>
            <div className='cell-header'>
              <h4>Percentile Trends</h4>
              <Button id="fullscreen-percentile" variant="flat" size="md" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'percentile' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
  
            <div className="cell-content">
              <LineChart
                id="percentiles-trend"
                className='chart'
                isFullScreen={this.state.isFullScreen === 'percentile'}
                tooltipLabel=""
                unit=""
                data={this.props.trends.percentiles}
              />
            </div>
          </div>

          <div className={`cell ${this.state.isFullScreen === 'fe' ? 'fullscreen' : ''}`}>
            <div className='cell-header'>
              <h4>Flow Efficiency Trends</h4>
              <Button variant="flat" size="md" onClick={() => { this.setState({ fe: !this.state.fe }); this.trackChartDetailsView('fe', this.state.fe); }} >
                <img src={this.state.fe ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
              </Button>
              <Button id="fullscreen-fe" variant="flat" size="md" onClick={this.handleResize}>
                <img src={this.state.isFullScreen === 'fe' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
              </Button>
            </div>
  
            <div className="cell-content">
              <LineChart
                id="fe"
                className='chart'
                detailed={this.state.fe}
                isFullScreen={this.state.isFullScreen === 'fe'}
                tooltipLabel="Avg. Flow Efficiency"
                unit="%"
                data={this.props.trends.flowEfficiency}
              />
            </div>
          </div>
        </div>      
      </div>
    ];
  }

  trialExpired() {
    return (
      !this.props.user.config ||
      moment(this.props.user.config.exportTrialEnd).diff(moment()) < 0 ||
      !this.props.user.config.exportEnabled
    );
  }

  render() {
    const { wallmode, streams, streamsLoaded, loaded } = this.props;
    const trialExpired = this.trialExpired();
    const emptyPath = streamsLoaded  && loaded ? streams && streams.length > 1 ? "no-portfolios": "no-enough-streams": null;
    return [
      !trialExpired && streamsLoaded && (
        <ValueStreamSelector
          key="1"
          title=""
          items={this.props.portfolios}
          selectedItem={this.props.selectedPortfolio}
          onSelect={this.props.selectPortfolio}
          onSaveSelected={this.props.saveSelectedPortfolio}
          onListAll={this.props.listAllPortfolios}
          loaded = {this.props.loaded}
          noItems={!this.props.portfolios || this.props.portfolios.length === 0}
          basePath="/portfolios"
          emptyPath={emptyPath}
          searchPlaceholder="Search Portfolio"
          defaultItemImage={portfolioIcon}
          defaultItemIdFromUserConfigKey="selectedPortfolio"
          buttons={wallmode ? null : this.renderButtons()}
          dataIsLoading={this.props.loading}
          showTeamInHeader={true}
        />
      ),
      !trialExpired && (
        <div key="2" id="portfolio" className="content-wrap">
          <Helmet title="Portfolio" />

          {this.renderPortfolio()}
        </div>
      ),
      trialExpired && (
        <div className="main expired">
          <Header showTeam={true} buttons={<SubscribeEDAddOn></SubscribeEDAddOn>} />
          <div className="centerContent">
            <div>
              <h1 className="title">Your trial has expired</h1>
            </div>
          </div>
        </div>
      )
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleError: err => dispatch(handleError(err)),
    requestData: id => dispatch(requestData(id)),    
    select: (itemId, viewId) => dispatch(selectPortfolio(itemId, viewId)),
    remove: id => dispatch(deletePortfolio(id)),
    listAllPortfolios: () => dispatch(listAll()),
    selectPortfolio: (item, viewId) => dispatch(selectPortfolio(item, viewId)),
    saveSelectedPortfolio: id => dispatch(saveSelected(id)),
    saveSelectedBreakdown: (id, chart, value) => dispatch(saveSelectedPortfolioBreakdown(id, chart, value)),
    getStreams: () => dispatch(streamsAll()),
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    wallmode: state.app.wallmode,
    loading: state.portfolio.isLoading,
    loaded: state.portfolio.loaded,
    stats: state.portfolio.stats,
    trends: state.portfolio.trends,
    portfolios: state.portfolio.portfolios,
    selectedPortfolio: state.portfolio.selectedPortfolio,
    user: state.auth.user,
    streams: state.report.streams,
    streamsLoading: state.report.isLoading,
    streamsLoaded: state.report.loaded,
    filters: state.report.filters,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Portfolios));
export { Portfolios };